import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ListItemText from "@mui/material/ListItemText";

export class StaticPageComponent extends React.Component {
    render() {
        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        {this.props.icon}

                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }} >{this.props.title}</strong></ListItemText>

                    </ToolbarMui>

                </AppBar>

                <Box style={{marginTop: 80}}>
                    <Typography style={{paddingLeft: 16,paddingRight: 16,paddingTop: 16,paddingBottom:100,whiteSpace: 'pre-line'}}>{this.props.content}</Typography>
                </Box>
            </React.Fragment>
        );
    }


}
